export default __webpack_public_path__ + "static/media/git-logo.2a98f350.svg";